var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 330.35 247.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4695c5;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #276bb0;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.06,240.27c-1.16,3.69-5.74,4.84-9.58,5.28-15.85,1.81-31.85,1.79-47.8,1.53-12.26-.2-24.56-.54-36.7-2.28-6.51-.92-12.94-2.25-19.37-3.57-1.22-.25-2.47-.51-3.48-1.22-.89-.63-1.57-1.7-1.49-2.77-.04,0-.08,0-.13-.04-.31-.22-.22-.7-.33-1.06-2.03-6.89-4.14-14.24-4.82-21.41-.02-.14-.02-.27-.02-.39,4.18,1.95,8.96,2.59,13.59,3.12,32.19,3.63,64.74,4.07,97.02,1.32,5.49-.46,11.2-1.1,15.91-3.89.17.39.21.85.23,1.28.44,8.13-.6,16.33-3.03,24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.79,205.31c-.44,1.07-1.69,1.52-2.81,1.81-6.12,1.64-12.44,2.55-18.78,2.72-.93,0-4.1-11.97-4.45-13.21-.36-1.26-.75-2.43-.97-3.51,7.25.05,15.98-4.06,22.47-9.66.17-.15.34-.31.5-.48.32.23.47.65.58,1.04,1.12,3.91.61,8.14,1.53,12.11.58,2.53,1.75,4.94,2.06,7.52.07.56.09,1.14-.13,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.06,190.92c-.51,6.62-1.56,13.19-3.14,19.64-7.61-1.18-15.12-3.04-22.4-5.56-.41-.14-.85-.31-1.07-.68-.17-.28-.18-.61-.19-.94-.09-4.58.37-9.16,1.35-13.64.43-1.96.88-5.21,1.88-7.63,1.65,1.92,3.92,3.4,7.35,5.04,4.97,2.36,10.72,4.31,16.22,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.75,182.98c-.16.17-.33.33-.5.48-6.49,5.6-15.22,9.71-22.47,9.66-1.76-.01-3.43-.27-4.96-.81-6.99-2.45-15.4-12.58-19.59-18.7-9.6-14-16.78-29.66-21.14-46.07.77,21.61-4.65,42.92-10.02,63.87-2.22,8.65-4.98,18.09-12.44,23-.25.17-.51.33-.77.48-4.71,2.79-10.42,3.43-15.91,3.89-32.28,2.75-64.83,2.31-97.02-1.32-4.63-.53-9.41-1.17-13.59-3.12-.9-.41-1.77-.89-2.61-1.44-7.22-4.75-10.27-13.69-12.32-22.08-6.46-26.35-7.83-53.94-4.04-80.81-9.16,24.29-18.47,48.86-33.32,70.14-2.31,3.3-4.83,6.6-8.31,8.63-2.14,1.25-4.39,1.91-6.68,2.14-5.5.54-11.25-1.41-16.22-3.77-3.43-1.64-5.7-3.12-7.35-5.04-1.91-2.23-2.98-5.05-4.04-9.38-3.99-16.34-1.07-33.64,3.12-49.63,6.2-23.69,15.39-46.82,29.39-66.91,14.01-20.08,34.08-35.09,56.75-44.34,15.52-6.33,31.51-9.3,48.07-11.85-.84,4.68,5.4,10.77,8.44,12.38,9.75,5.16,19.83,6.56,30.78-1.87,4.34-3.34,2.93-8.34,2.93-8.34,0,0,5.27-1.16,7.98-.95,34.52,2.72,66.73,21.51,89.2,47.86,22.47,26.35,35.69,59.75,41.41,93.9,2.32,13.84,1.54,33.61-4.77,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.12,4.69c9.89,18.29,21.7,24.13,37.97,25.82,8.41.87,19.12-.74,26.57-4.75,7.45-4.01,13.46-10.96,15.5-19.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.2,193.23c6.8-.76,13.43-2.96,19.33-6.41,1.42-.83,2.87-1.81,3.54-3.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.94,182.64c6.85,4.99,15.65,6.23,24.06,7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.16,215.66c5.94,2.85,12.59,3.83,19.13,4.58,34.72,3.98,70.05,2.65,104.37-3.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.71,93.68c3.92,12.73,8.87,25.15,14.77,37.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M83.58,111.11c4.99-8.51,8.71-17.76,10.99-27.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M236.12,19.89c3.64-3,7.45-5.79,11.41-8.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.18,30.4c3.03,2.51,6.05,5.03,9.08,7.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.28,52.76c4.07,1.77,8.27,3.25,12.56,4.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.36,58.24c-2.07,4.86-3.9,9.83-5.45,14.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M285.92,89.12c3.91,1.53,7.82,3.06,11.74,4.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.12,112.36c-3.14,3.65-5.69,7.81-7.52,12.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.07,71.99c4.67-.49,9.35-.98,14.02-1.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.4,117.77c3.08,3.67,6.33,7.21,9.73,10.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M320,162.41c2.98,3.41,6.09,6.69,9.35,9.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282.48,177.02l-3.15,8.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.6,147.25c4.57,2.5,9.14,5,13.71,7.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.03,103.12c3.92,1.7,8.04,2.95,12.24,3.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.36,150.12c3.01,2.74,6.18,5.31,9.47,7.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M304.81,173.59c-1.76,3.94-3.09,8.09-3.94,12.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.78,186.77c3.19,2.03,6.38,4.06,9.56,6.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.96,178.92c2.25-2.81,4.74-5.43,7.44-7.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.22,150.55c2.49,1.85,5.16,3.46,7.94,4.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.35,124.18c1.01,3.51,2.53,6.88,4.5,9.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.45,153.5c2.07,3.14,4.41,6.1,6.99,8.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.74,174.63c-.14,4.43-.28,8.86-.42,13.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.03,155.65c4.28,1.43,8.66,2.54,13.1,3.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4.55,142.01c2.78-2.85,6.01-5.25,9.53-7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1,164.47c2.63-1.86,5.37-3.57,8.19-5.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.64,110.29c4.37,1.12,8.82,1.98,13.29,2.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.12,79.44c3.19-1.36,6.43-2.59,9.72-3.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.21,63.19c3.26,1.38,6.51,2.75,9.77,4.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.2,94.67c-1.85,3.64-3.58,7.34-5.2,11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.96,125.36c3.3,3.88,7.07,7.35,11.21,10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.84,33.2c4.33,2.04,8.66,4.08,13,6.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.65,41.37l14.69,1.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.65,10.61c4.33,2.48,8.76,4.79,13.28,6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.16,47.22c3.75-2.75,7.88-4.99,12.22-6.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.5,24.19c4.28,2.92,8.55,5.84,12.83,8.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.23,82.35c4.54,3.14,9.34,5.89,14.34,8.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.56,70.77c4.55,2.41,9.09,4.82,13.64,7.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.92,111.72c3.01,1.68,6.02,3.37,9.03,5.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.99,132.37c-1.28,3.16-2.39,6.38-3.31,9.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.62,159.02c3.22,1.15,6.37,2.48,9.45,3.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.51,189.91c-2.01,2.43-3.71,5.11-5.06,7.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.65,156.87c2.96,2.35,6.22,4.32,9.69,5.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M151.34,116.36c3.93,1.34,7.85,2.69,11.78,4.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M158.62,83.08c-1.08,3.23-2.17,6.45-3.25,9.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.12,53.62c3.38,1.6,6.84,3.02,10.37,4.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.5,68.48c-1.35,3.24-2.55,6.54-3.57,9.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.68,44.9c3.29,1.51,6.59,3.02,9.88,4.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.62,68.49c3.6.79,7.2,1.57,10.8,2.36.45.1.99.28,1.06.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M220.93,95.57c2.25,3.06,5.04,5.72,8.2,7.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.18,118.18c2.86,2.12,5.9,4.02,9.05,5.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.56,140.39c-.71,3.3-1.42,6.6-2.13,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.23,153.81c2.86,2.89,5.83,5.66,8.92,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.39,145.11c2.97-.83,5.95-1.67,8.92-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.81,165.14c.41,2.92,1.2,5.78,2.33,8.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.74,178.8c3.34,1.42,6.82,2.52,10.38,3.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.64,191.77c1.97,3.07,4.17,6,6.57,8.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.63,202.39c-.58,2.87-.95,5.79-1.09,8.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.38,193.33c.88,3.2,1.75,6.39,2.63,9.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.39,173.8c2.09,1.57,4.18,3.14,6.28,4.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.39,29h14.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.36,222.81c.58,4.66,1.53,9.27,2.84,13.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.3,225.56c.56,4.71,1.12,9.41,1.67,14.12.05.42.5.96.74.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.99,226.94c.45,4.46.9,8.91,1.35,13.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M187,226.25c.63,4.83,1.38,9.63,2.25,14.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.08,223.84c.45,5.14.9,10.28,1.35,15.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M306.84,194.89c.62,3.61,1.54,7.17,2.74,10.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M315.73,192.45c.91,3.2,1.83,6.4,2.74,9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.43,190.34c-.68,4.18-1.6,7.88-2.07,11.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.27,192.96c-.46,4.63-1.28,6.17-2.01,12.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.16,9.08c2.97-.93,5.98-1.71,9.03-2.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.92,19.45c2.38-1.72,4.75-3.44,7.13-5.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.09,18.25c-.74,2.57-1.32,5.19-1.74,7.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.57,18.93c1.23,2.31,2.3,4.7,3.2,7.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.45,14.17c1.66,1.54,3.56,2.82,5.61,3.79.52.25,1.06.48,1.45.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.36,5.99c3.06.85,6.12,1.7,9.18,2.55"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarm);
export default __webpack_public_path__ + "static/media/warm.2e249a85bae077809e0a1e7c54903968.svg";
export { ForwardRef as ReactComponent };